<template>
    <v-container fluid class="pa-6">
        <v-card>
            <v-card-title class="headline">
                Panel de Soporte Distribuidor
            </v-card-title>
            <v-card-subtitle>
                Accede como uno de tus usuarios para gestionar su cuenta
            </v-card-subtitle>
            <v-card-text>
                <v-row align="center">
                    <v-col cols="12" md="6">
                        <v-autocomplete
                            label="Selecciona un usuario"
                            v-model="selectedUser"
                            :items="distributorUsers"
                            item-value="id"
                            item-text="username"
                            return-object
                            :loading="loadingUsers"
                            :disabled="loadingUsers"
                            clearable
                            outlined
                            dense
                            prepend-inner-icon="mdi-account-search"
                            placeholder="Buscar usuario..."
                            no-data-text="No se encontraron usuarios"
                        ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" md="3">
                        <v-btn
                            color="primary"
                            :disabled="!selectedUser || loadingLoginas"
                            :loading="loadingLoginas"
                            @click="doLoginas"
                            block
                        >
                            <v-icon left>mdi-account-switch</v-icon>
                            Acceder como usuario
                        </v-btn>
                    </v-col>
                </v-row>

                <v-alert
                    v-if="error"
                    type="error"
                    dismissible
                    class="mt-4"
                    @input="error = ''"
                >
                    {{ error }}
                </v-alert>

                <v-alert
                    type="info"
                    outlined
                    class="mt-4"
                >
                    <strong>Nota:</strong> Al acceder como otro usuario, podras ver y gestionar su cuenta.
                    Para volver a tu cuenta, haz clic en el nombre de usuario en la barra superior.
                </v-alert>
            </v-card-text>
        </v-card>

        <!-- Info de usuarios del distribuidor -->
        <v-card class="mt-4" v-if="distributorUsers.length > 0">
            <v-card-title>
                <v-icon left>mdi-account-group</v-icon>
                Tus usuarios ({{ distributorUsers.length }})
            </v-card-title>
            <v-card-text>
                <v-simple-table dense>
                    <template v-slot:default>
                        <thead>
                            <tr>
                                <th class="text-left">Usuario</th>
                                <th class="text-left">Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="user in distributorUsers" :key="user.id">
                                <td>{{ user.username }}</td>
                                <td>
                                    <v-btn
                                        small
                                        color="primary"
                                        text
                                        @click="selectAndLoginas(user)"
                                        :loading="loadingLoginas && selectedUser && selectedUser.id === user.id"
                                    >
                                        <v-icon small left>mdi-login</v-icon>
                                        Acceder
                                    </v-btn>
                                </td>
                            </tr>
                        </tbody>
                    </template>
                </v-simple-table>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { query_dispatcher } from '@/api/client';

export default {
    name: 'DebugDistribuidor',
    data() {
        return {
            selectedUser: null,
            distributorUsers: [],
            loadingUsers: false,
            loadingLoginas: false,
            error: '',
        };
    },
    computed: {
        ...mapGetters('me', ['userData']),
    },
    mounted() {
        this.loadDistributorUsers();
    },
    methods: {
        ...mapActions(['setLoginasDistributor']),

        async loadDistributorUsers() {
            this.loadingUsers = true;
            this.error = '';
            try {
                const response = await query_dispatcher.dispatch('get.distributor.users', {});
                if (response && response.data) {
                    this.distributorUsers = response.data;
                } else {
                    this.distributorUsers = [];
                }
            } catch (err) {
                console.error('Error loading distributor users:', err);
                this.error = 'Error al cargar los usuarios. Por favor, intenta de nuevo.';
                this.distributorUsers = [];
            } finally {
                this.loadingUsers = false;
            }
        },

        selectAndLoginas(user) {
            this.selectedUser = user;
            this.doLoginas();
        },

        async doLoginas() {
            if (!this.selectedUser) {
                this.error = 'Por favor, selecciona un usuario';
                return;
            }

            this.loadingLoginas = true;
            this.error = '';

            try {
                await this.setLoginasDistributor(this.selectedUser.username);
                // Recargar la pagina para aplicar el loginas
                this.$router.go();
            } catch (err) {
                console.error('Error during loginas:', err);
                if (err.response && err.response.data && err.response.data.error) {
                    this.error = err.response.data.error;
                } else {
                    this.error = 'Error al acceder como usuario. Por favor, intenta de nuevo.';
                }
            } finally {
                this.loadingLoginas = false;
            }
        },
    },
};
</script>

<style scoped>
.v-card {
    max-width: 900px;
    margin: 0 auto;
}
</style>
